/**
 * Indian number grouping with exactly two fraction digits (e.g. 11,350.00).
 */
export function formatInr(value) {
  return Number(value ?? 0).toLocaleString('en-IN', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
}
